/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IPartitionApi {
    getPartition(cancelToken?: CancelToken): AxiosPromise<PartitionModel>;
    getPartitionSettings(cancelToken?: CancelToken): AxiosPromise<PartitionSettings>;
    updatePartitionSettings(
        request: UpdatePartitionSettingsRequest,
        cancelToken?: CancelToken,
    ): AxiosPromise<void>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_PartitionApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_PartitionApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class PartitionApi implements IPartitionApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_PartitionApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_PartitionApi) @optional() axiosInstance = axios,
    ) {
        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getPartition(cancelToken?: CancelToken): AxiosPromise<PartitionModel> {
        let url_ = '/marketing/api/brands/Partition/get';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return this.opts.axios.request<PartitionModel>(options_);
    }

    getPartitionSettings(cancelToken?: CancelToken): AxiosPromise<PartitionSettings> {
        let url_ = '/marketing/api/brands/Partition/settings';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return this.opts.axios.request<PartitionSettings>(options_);
    }

    updatePartitionSettings(
        request: UpdatePartitionSettingsRequest,
        cancelToken?: CancelToken,
    ): AxiosPromise<void> {
        let url_ = '/marketing/api/brands/Partition/settings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.opts.axios.request<void>(options_);
    }
}

export interface PartitionModel {
    id: string;
    isCorporate: boolean;
}

export interface PartitionSettings {
    tenantId: string;
    defaultBrand?: string | undefined;
    emailSettings: EmailSettings;
}

export interface EmailSettings {
    emailMonthlyCost: number;
}

export interface UpdatePartitionSettingsRequest {
    emailSettings: EmailSettingsUpdateModel;
}

export interface EmailSettingsUpdateModel {
    emailMonthlyCost: number;
}
